import { forwardRef } from 'react';

import {
  useMonkeysBaseAppearance,
  useMonkeysComponentAttributes,
} from '../../provider/context';
import { resolveBaseAppearance } from './theme';
import type { BaseKbdProps } from './types';
import { cn } from './utils';

export const BaseKbd = forwardRef<HTMLElement, BaseKbdProps>(function BaseKbd(
  {
    children,
    appearance,
    className,
    classNames,
    style,
    ...kbdProps
  },
  ref,
) {
  const resolvedAppearance = useMonkeysBaseAppearance(appearance);
  const componentAttributes = useMonkeysComponentAttributes();
  const theme = resolveBaseAppearance(resolvedAppearance);

  return (
    <kbd
      {...componentAttributes}
      {...kbdProps}
      ref={ref}
      data-monkeys-component="kbd"
      data-slot="root"
      className={cn(theme.slots.kbdRoot, classNames?.root, className)}
      style={{
        ...theme.styles.kbd,
        ...style,
      }}
    >
      {children}
    </kbd>
  );
});
